module.exports = __webpack_public_path__ + "static/media/intro4.23c9bff3.png";